import config from "../config";

const CounterModel = {
  fetchCounter: async () => {
    try {
      const response = await fetch(config.counterApiUrl);
      const data = await response.json();
      return data.counter;
    } catch (error) {
      console.error("Error fetching counter:", error);
    }
  },
};

export default CounterModel;
